import { useCallback, useMemo } from 'react'

import { useQuery } from '@shared/modules/use-query/hooks'
import { UseQueryOptions } from '@shared/modules/use-query/types'

import { WarehouseMappers } from '../mappers'
import { WarehousesService } from '../services'
import { WarehouseFormData } from '../types'

export const useWarehouseFormInitialData = ({ id, initialValues }: { id?: string; initialValues?: WarehouseFormData }) => {
  return useQuery<WarehouseFormData>(
    useCallback(async () => {
      const result = await WarehousesService.getOneById(id as string)

      if (result.status === 200) {
        return WarehouseMappers.formInitializer(result.data)
      } else {
        return initialValues
      }
    }, [initialValues, id]),
    useMemo<UseQueryOptions>(
      () => ({
        initialData: initialValues,
        enabled: !!id,
      }),
      [initialValues, id],
    ),
  )
}
